import React from 'react'

export interface Props {
  message: string

  component?: React.FunctionComponent<any> | string
}

export const FormattedHtmlMessage: React.FC<Props> = ({
  message,
  component: Component = 'span',
  ...rest
}) => (
  <Component
    dangerouslySetInnerHTML={{
      __html: message,
    }}
    {...rest}
  />
)

export default FormattedHtmlMessage
